import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    custom: {
      main: "#FDDB32",
      second: "#D89E27",
    },
  },
  typography: {
    button: {
      textTransform: "unset",
    },
  },
});
